import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import Dismantling from "@/pages/Dismantling";
import Machinery from "@/pages/Machinery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <LanguageProvider>
            <SmoothScroll />
            <ScrollToTop />
            <div className="min-h-screen bg-[#0A0B10] text-slate-100">
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/inventory" element={<Inventory />} />
                  <Route path="/inventory/:id" element={<VehicleDetail />} />
                  <Route path="/dismantling" element={<Dismantling />} />
                  <Route path="/machinery" element={<Machinery />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/ro" element={<Home />} />
                  <Route path="/ro/inventory" element={<Inventory />} />
                  <Route path="/ro/inventory/:id" element={<VehicleDetail />} />
                  <Route path="/ro/dismantling" element={<Dismantling />} />
                  <Route path="/ro/machinery" element={<Machinery />} />
                  <Route path="/ro/about" element={<About />} />
                  <Route path="/ro/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppButton />
            </div>
            <Toaster position="bottom-right" theme="dark" />
          </LanguageProvider>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
